export default {
  // System Common
  'sys.serialNumber': 'No.',
  'sys.status': 'Status',
  'sys.operation': 'Operation',
  'sys.cancel': 'Cancel',
  'sys.confirm': 'Confirm',
  'sys.add': 'Add',
  'sys.edit': 'Edit',
  'sys.preview': 'Preview',
  'sys.delete': 'Delete',
  'sys.enable': 'Enable',
  'sys.disable': 'Disable',
  'sys.search': 'Search',
  'sys.reset': 'Reset',
  'sys.total': 'Total {total} items',
  'sys.addSuccess': 'Added successfully',
  'sys.editSuccess': 'Edited successfully',
  'sys.deleteSuccess': 'Deleted successfully',
  'sys.enableSuccess': 'Enabled successfully',
  'sys.disableSuccess': 'Disabled successfully',
  'sys.addFailed': 'Add failed',
  'sys.editFailed': 'Edit failed',
  'sys.deleteFailed': 'Delete failed',
  'sys.enableFailed': 'Enable failed',
  'sys.disableFailed': 'Disable failed',
  'sys.confirmDelete': 'Are you sure you want to delete?',
  'sys.confirmEnable': 'Are you sure you want to enable?',
  'sys.confirmDisable': 'Are you sure you want to disable?',
  'sys.required': 'Required',
  'sys.pleaseSelect': 'Please select',
  'sys.pleaseEnter': 'Please enter',
  'sys.all': 'All',
  'sys.enabled': 'Enabled',
  'sys.disabled': 'Disabled',
  'sys.operator': 'Operator',
  'sys.operateTime': 'Operation Time',

  // Email Template Modal
  'email.template.modal.title.edit': 'Edit Email Template',
  'email.template.modal.title.add': 'Add Email Template',
  'email.template.modal.language': 'Language',
  'email.template.modal.language.placeholder': 'Please select language',
  'email.template.modal.businessType': 'Business Type',
  'email.template.modal.businessType.placeholder': 'Please select business type',
  'email.template.modal.subject': 'Email Subject',
  'email.template.modal.subject.placeholder': 'Please enter email subject',
  'email.template.modal.content': 'Email Template',
  'email.template.modal.content.placeholder': 'Please enter email content',
  'email.template.modal.sender': 'Display Sender',
  'email.template.modal.sender.placeholder': 'Please enter display sender',
  'email.template.modal.format': 'Email Format',
  'email.template.modal.format.placeholder': 'Please select email format',
  'email.template.modal.receipt': 'Receipt Required',
  'email.template.modal.receipt.placeholder': 'Please select if receipt is required',
  'email.template.modal.receipt.yes': 'Yes',
  'email.template.modal.receipt.no': 'No',

  // Email Config Modal
  'email.config.modal.title.edit': 'Edit Email',
  'email.config.modal.title.add': 'Add Email',
  'email.config.modal.type': 'Email Type',
  'email.config.modal.type.placeholder': 'Please select email type',
  'email.config.type.80002001': 'Microsoft Email',
  'email.config.type.80002002': 'Google Email',
  'email.config.modal.account': 'Email Address',
  'email.config.modal.account.placeholder': 'Please enter email address',
  'email.config.modal.password': 'Email Password',
  'email.config.modal.password.placeholder': 'Please enter email password',
  'email.config.modal.smtp': 'SMTP',
  'email.config.modal.smtp.placeholder': 'Please enter SMTP address',
  'email.config.modal.port': 'Port',
  'email.config.modal.port.placeholder': 'Please enter port number',

  // Email Template List
  'email.template.list.title': 'Email Template List',
  'email.template.list.search.businessType': 'Business Type',
  'email.template.list.search.language': 'Language',
  'email.template.list.search.button': 'Search',
  'email.template.list.search.reset': 'Reset',
  'email.template.list.add': 'Add',
  'email.template.list.edit': 'Edit',
  'email.template.list.enable': 'Enable',
  'email.template.list.disable': 'Disable',
  'email.template.list.delete': 'Delete',
  'email.template.list.delete.confirm': 'Are you sure you want to delete?',
  'email.template.list.status.enabled': 'Enabled',
  'email.template.list.status.disabled': 'Disabled',
  'email.template.list.operator': 'Operator',
  'email.template.list.operateTime': 'Operation Time',

  // Email Config List
  'email.config.list.title': 'Email Configuration List',
  'email.config.list.search.status': 'Status',
  'email.config.list.search.status.all': 'All',
  'email.config.list.search.status.enabled': 'Enabled',
  'email.config.list.search.status.disabled': 'Disabled',
  'email.config.list.search.account': 'Email Address',
  'email.config.list.search.account.placeholder': 'Please enter email address',
  'email.config.list.search.button': 'Search',
  'email.config.list.search.reset': 'Reset',
  'email.config.list.add': 'Add Email',
  'email.config.list.edit': 'Edit',
  'email.config.list.enable': 'Enable',
  'email.config.list.disable': 'Disable',
  'email.config.list.delete': 'Delete',
  'email.config.list.delete.confirm': 'Are you sure you want to delete?',
  'email.config.list.status.enabled': 'Enabled',
  'email.config.list.status.disabled': 'Disabled',
  'email.config.list.operator': 'Operator',
  'email.config.list.operateTime': 'Operation Time',
}; 